import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AssociationService } from '../../../../../../services/association/association.service';
import { ApplicationFieldConfig, Association } from '../../../../../../models/association';

@Component({
  selector: 'app-create-new-association-modal',
  templateUrl: './create-new-association-modal.component.html',
  styleUrls: ['./create-new-association-modal.component.css']
})
export class CreateNewAssociationModalComponent {

  @Input() savedCallback: (createdAssociation: Association) => undefined;

  public newAssociation: Association = {
    id: null,
    url: null,
    name: '',
    verification_requirements: '',
    automatic_removal_dates: [],
    show_reverification_alert: true,
    allow_automatic_entry_pass_use: false,
    membership_expiration_age: null,
    allow_customer_applications: false,
    application_document_field_config: ApplicationFieldConfig.none,
    application_text_field_config: ApplicationFieldConfig.none,
    application_document_field_name: '',
    application_text_field_name: '',
    application_customer_instructions: '',
    auto_add_on_event_booking_types: [],
    auto_add_on_event_booking_categories: [],
    auto_add_on_event_check_in_types: [],
    auto_add_on_event_check_in_categories: [],
    auto_add_on_entry_pass_use_pass_types: [],
    auto_add_on_entry_pass_use_only_first: false,
    auto_add_on_guest_pass_check_in: false,
    auto_add_on_guest_pass_check_in_only_first: false,
    member_square_customer_group_id: null,
    member_square_customer_group_name: null,
    member_lightspeed_customer_group_id: null,
    member_lightspeed_customer_group_name: null,
    num_members: 0,
    alerts_url: null,
    activity_log_url: null,
    created_at: null,
    updated_at: null
  };

  public name = '';

  public loadingSubmit = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private associationService: AssociationService
  ) {}

  public handleSubmit() {
    this.errorMessage = '';

    if (this.newAssociation.name === '') {
      this.errorMessage = 'Name is required.';
      return;
    }

    this.loadingSubmit = true;

    this.associationService
      .addAssociation(this.newAssociation)
      .then(createdAssociation => {
        this.savedCallback(createdAssociation);
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create associations.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
